class ClaudeService {
    constructor(_apiKey) {
        // API key is no longer used client-side; calls go through the proxy server
    }

    async askQuestion(question) {
        try {
            const response = await fetch('/api/claude/ask', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ question }),
            });
            const data = await response.json();
            if (data.text) return data.text;
            throw new Error('Invalid response from Claude API');
        } catch (error) {
            console.error('Error in askQuestion:', error);
            throw error;
        }
    }

    async modernizeText(text) {
        try {
            const response = await fetch('/api/claude/modernize', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ text }),
            });
            const data = await response.json();
            if (data.text) return data.text;
            throw new Error('Invalid response from Claude API');
        } catch (error) {
            console.error('Error in modernizeText:', error);
            throw error;
        }
    }

    async explainText(text, contextData) {
        try {
            const response = await fetch('/api/claude/explain', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ text, contextData }),
            });
            const data = await response.json();
            if (data.text) return data.text;
            throw new Error('Invalid response from Claude API');
        } catch (error) {
            console.error('Error in explainText:', error);
            throw error;
        }
    }

    async getHistoricalContext(contextData) {
        try {
            const response = await fetch('/api/claude/historical-context', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ contextData }),
            });
            const data = await response.json();
            if (data.text) return data.text;
            throw new Error('Invalid response from Claude API');
        } catch (error) {
            console.error('Error in getHistoricalContext:', error);
            throw error;
        }
    }
}

export default ClaudeService;
